import { useState } from "react";
import 'react-accessible-accordion/dist/fancy-example.css';
import { FaSpinner } from "react-icons/fa";
import { connect, useDispatch } from "react-redux";
import { Col, Input, Row } from "reactstrap";
import swal from "sweetalert";
import "../../../css/settings.scss";
import { logout } from "../../../store/actions/AuthActions";
import { api } from "../../../utils/api";
import { translate } from "../../../utils/translate";

const ChangePassword = (props) => {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        current_password: "",
        new_password: '',
        confirm_password: "",
    });
    let errorObj = { current_password: '', new_password: '', confirm_password: "" };
    const [errors, setErrors] = useState(errorObj);
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [loading, setLoading] = useState(false);


    const handleAddFormChange = (event) => {
        event.preventDefault();
        const fieldName = event.target.getAttribute('name');
        let fieldValue = event.target.value;
        const newFormData = { ...formData };
        newFormData[fieldName] = fieldValue;
        setFormData(newFormData);
    }
    const submit = () => {
        let check = true;
        const errorMsg = { ...errorObj };
        if (!formData.current_password) {
            errorMsg.current_password = 'This field is required.';
            check = false;
        }
        if (!formData.new_password) {
            errorMsg.new_password = 'This field is required.';
            check = false;
        } else {
            if (formData.new_password.length < 6) {
                errorMsg.new_password = 'Password must at least 6 characters';
                check = false;
            }
        }
        if (!formData.confirm_password) {
            errorMsg.confirm_password = 'This field is required.';
            check = false;
        }

        if (formData.new_password && formData.confirm_password) {
            if (formData.new_password !== formData.confirm_password) {
                errorMsg.confirm_password = "Confirm password need to same with password";
                check = false;
            }
        }

        setErrors(errorMsg);
        if (check) {
            setLoading(true);
            fetch(api.change_password, {
                method: "PUT",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "Accept-Language": props.lang,
                    "Authorization": "Bearer " + props.auth.auth.access_token

                }),
                body: JSON.stringify(formData)
            })
                .then(response => response.json())
                .then(responseJson => {
                    setLoading(false);
                    if (responseJson.status === "success") {
                        swal(translate(props.lang, 'Success'), responseJson.message, "success");
                        resetForm();
                    } else {
                        if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                            dispatch(logout(props.history, 'login'));
                        }
                        if (responseJson.data && typeof responseJson.data.error === 'object') {
                            let apiErrorMsg = { ...errorObj };
                            let popupMessage = [];
                            Object.keys(responseJson.data.error).map((key) => {
                                apiErrorMsg[key] = responseJson.data.error[key];
                                popupMessage.push(responseJson.data.error[key]);
                            })
                            setErrors(apiErrorMsg);
                            swal(translate(props.lang, "Error"), popupMessage.join('\n'), "error");
                        } else {
                            swal(translate(props.lang, "Error"), responseJson.message, "error");
                        }
                    }
                }).catch(error => {
                    console.error("error", error);
                });
        }
    }

    const resetForm = () => {
        setFormData({
            current_password: "",
            new_password: '',
            confirm_password: "",
        })
    }
    return (
        <>
            <div className='pb-5 wallet'>
                <Row className="mx-0 px-0 mt-3 mt-md-0">
                    <Col lg={12} md={12} sm={12} xs={12} className="px-0">
                        <div className="whiteContainer py-4">
                            <div className="px-5 py-4">
                                <span className="infoTitle">{translate(props.lang, "Change Password")}</span>
                                <Row className="mt-5">


                                    <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                                        <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Old Password")}</span>
                                        <div className={`groupLabel-input ${errors.current_password ? 'errorBorder' : ''}  mt-2 mb-1`}>
                                            <div className="input-group">
                                                <Input
                                                    type={showOldPassword ? "text" : "password"}
                                                    placeholder={translate(props.lang, "Enter Old Password")}
                                                    className="form-control input-transparent py-1 px-3"
                                                    onChange={e => handleAddFormChange(e)}
                                                    name="current_password"
                                                    value={formData.current_password}
                                                />
                                                <div className='d-flex align-items-center justify-content-end transparent-bg pe-3 pe-md-4' onClick={() => setShowOldPassword(!showOldPassword)}>
                                                    {showOldPassword ? (
                                                        <img src={require('../../../images/icon/eyeSlash.svg').default} className="img-fluid" alt="icon" />
                                                    ) : (
                                                        <img src={require('../../../images/icon/eye.svg').default} className="img-fluid" alt="icon" />
                                                    )}

                                                </div>
                                            </div>
                                        </div>
                                        <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.current_password)}</span>
                                    </Col>
                                    <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                                        <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "New Password")}</span>
                                        <div className={`groupLabel-input  ${errors.new_password ? 'errorBorder' : ''}  mt-2 mb-1`}>
                                            <div className="input-group">
                                                <Input
                                                    type={showNewPassword ? "text" : "password"}
                                                    placeholder={translate(props.lang, "Enter New Password")}
                                                    className="form-control input-transparent py-1 px-3"
                                                    onChange={e => handleAddFormChange(e)}
                                                    name="new_password"
                                                    value={formData.new_password}

                                                />
                                                <div className='d-flex align-items-center justify-content-end transparent-bg pe-3 pe-md-4' onClick={() => setShowNewPassword(!showNewPassword)}>
                                                    {showNewPassword ? (
                                                        <img src={require('../../../images/icon/eyeSlash.svg').default} className="img-fluid" alt="icon" />
                                                    ) : (
                                                        <img src={require('../../../images/icon/eye.svg').default} className="img-fluid" alt="icon" />
                                                    )}

                                                </div>
                                            </div>
                                        </div>
                                        <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.new_password)}</span>

                                    </Col>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Confirm Password")}</span>
                                        <div className={`groupLabel-input ${errors.confirm_password ? 'errorBorder' : ''}  mt-2 mb-1`}>
                                            <div className="input-group">
                                                <Input
                                                    type={showConfirmPassword ? "text" : "password"}
                                                    placeholder={translate(props.lang, "Enter Confirm Password")}
                                                    className="form-control input-transparent py-1 px-3"
                                                    onChange={e => handleAddFormChange(e)}
                                                    name="confirm_password"
                                                    value={formData.confirm_password}
                                                />
                                                <div className='d-flex align-items-center justify-content-end transparent-bg pe-3 pe-md-4' onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                                    {showConfirmPassword ? (
                                                        <img src={require('../../../images/icon/eyeSlash.svg').default} className="img-fluid" alt="icon" />
                                                    ) : (
                                                        <img src={require('../../../images/icon/eye.svg').default} className="img-fluid" alt="icon" />
                                                    )}

                                                </div>
                                            </div>
                                        </div>
                                        <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.confirm_password)}</span>
                                    </Col>
                                    <Col lg={12} md={12} sm={12} xs={12} className="mt-4">
                                        <button className="primary-btn px-4 py-1 text-center mx-auto w-100" onClick={() => submit()}>
                                            <span className={`font-weight-600 font-20 line-height-30 text-white`}>{loading ? <FaSpinner className="fa-spin" /> : translate(props.lang, "Update")}</span>
                                        </button>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    )
}

const mapStateToProps = state => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
}

export default connect(mapStateToProps)(ChangePassword);